import { useMatch } from "react-router-dom-v5-compat";

import { Box } from "@seneca/senekit";

import AssignmentExamQuestionsRow from "features/classroom/pages/classroom/components/EndSession/assignment-progress/components/AssignmentExamQuestionsRow/AssignmentExamQuestionsRow";
import ExamQuestionsCount from "features/classroom/pages/classroom/components/EndSession/assignment-progress/components/AssignmentExamQuestionsRow/components/ExamQuestionsCount";
import ExamQuestionsProgressIndicator from "features/classroom/pages/classroom/components/EndSession/assignment-progress/components/AssignmentExamQuestionsRow/components/ExamQuestionsProgressIndicator";
import { makeLinkToAssignmentExamQuestionsSessionWithState } from "features/classroom/routes/classroom/routes/course/routes/course-exam-questions/links";
import { ROUTES } from "routing/routes";

type LinkToExamQuestionSessionProps = {
  assignedQuestionIds: string[];
  courseId: string;
  assignmentId: string;
  score: number;
  scoreRatioDisplay: string;
  numOfQuestionsAssigned: number;
  numOfQuestionsToStudy: number;
};

export function LinkToExamQuestionSession(
  props: LinkToExamQuestionSessionProps
) {
  const {
    assignedQuestionIds,
    courseId,
    assignmentId,
    score,
    scoreRatioDisplay,
    numOfQuestionsAssigned,
    numOfQuestionsToStudy
  } = props;

  const currentUrlMatch = useMatch(ROUTES.CLASSROOM.COURSE.EXAM_QUESTIONS.path);

  const linkToStartSession =
    numOfQuestionsToStudy > 0
      ? makeLinkToAssignmentExamQuestionsSessionWithState({
          courseId,
          selectedQuestionIds: assignedQuestionIds,
          assignmentId
        })
      : null;

  return (
    <Box
      paddingY="small"
      display="flex"
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
    >
      <AssignmentExamQuestionsRow
        linkToStartSession={linkToStartSession}
        active={!!currentUrlMatch}
      >
        {{
          count: (
            <Box paddingX="large" paddingY="small">
              <ExamQuestionsCount
                numOfQuestionsAssigned={numOfQuestionsAssigned}
                numOfQuestionsToStudy={numOfQuestionsToStudy}
              />
            </Box>
          ),
          scoreIndicator: (
            <Box paddingX="large" paddingY="small">
              <ExamQuestionsProgressIndicator
                score={score}
                scoreRatioDisplay={scoreRatioDisplay}
                fontSize="xsmall"
              />
            </Box>
          )
        }}
      </AssignmentExamQuestionsRow>
    </Box>
  );
}
